import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AutoCompleteComponent } from '../auto-complete.component';
import { AutoCompleteItem } from '../interfaces/autocomplete-item';

@Component({
    selector: 'app-auto-complete-list-by-selection',
    templateUrl: './auto-complete-list-by-selection.component.html',
    styleUrls: ['./auto-complete-list-by-selection.component.scss'],
    standalone: false
})
export class AutoCompleteListBySelectionComponent extends AutoCompleteComponent {
  selectedItems: AutoCompleteItem[] = [];
  @Input() isDisabled = false;
  @Input() showAddNewGroupButton = false;
  @Input() inputId: string | undefined;
  @Output() addNewGroup = new EventEmitter<void>();

  get effectiveInputId(): string {
    return this.inputId ?? 'auto-complete-list-by-selection';
  }

  @Input() set selectedItemsData(selectedItems: AutoCompleteItem[]) {
    if (!selectedItems) {
      return;
    }

    this.selectedItems = [...selectedItems];
  }

  @Output() clearChange = new EventEmitter<AutoCompleteItem[]>();

  constructor(liveAnnouncer: LiveAnnouncer, translate: TranslateService) {
    super(liveAnnouncer, translate);
  }

  onClear(): void {
    this.clearChange.emit();
  }

  onAddNewGroupClick(): void {
    this.addNewGroup.emit();
  }
}
